import {IScopeMySuffix} from 'src/app/shared/model//scope-my-suffix.model';
import {FileDataMySuffix,IFileDataMySuffix} from 'src/app/shared/model/file-data-my-suffix.model';
import {IPolicyMySuffix} from './policy-my-suffix.model';

export const enum ClauseExtensionType {
    CLAUSE = 'CLAUSE',
    EXTENSION = 'EXTENSION',
    BOTH = 'BOTH'
}

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface IClauseExtensionMySuffix {
    id?: number;
    clauseExtensionType?: ClauseExtensionType;
    name?: string;
    clauseDescrition?: string;
    extensionDescription?: string;
    activeStatus?: ActiveStatus;
    fileId?: string;
    fileDTO?: IFileDataMySuffix;
    scopeClauses?: IScopeMySuffix[];
    scopeExtensions?: IScopeMySuffix[];
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    fromEffectiveDate?: string;
    policies?: IPolicyMySuffix[];
}

export class ClauseExtensionMySuffix implements IClauseExtensionMySuffix {
    constructor(
        public id?: number,
        public clauseExtensionType?: ClauseExtensionType,
        public name?: string,
        public clauseDescrition?: string,
        public extensionDescription?: string,
        public activeStatus?: ActiveStatus,
        public fileId?: string,
        public fileDTO = new FileDataMySuffix(),
        public scopeClauses?: IScopeMySuffix[],
        public scopeExtensions?: IScopeMySuffix[],
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public fromEffectiveDate?: string,
        public policies?: IPolicyMySuffix[]
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        this.clauseDescrition = '';
        this.extensionDescription = '';
        this.name = '';
    }
}
